// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-alert-address {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: 2.3px solid var(--color-warning);
  border-radius: 20px !important;
  padding: var(--spacing-regular);
  height: auto;
  margin-top: var(--spacing-regular);
}
.container-alert-address .text-alert-address {
  font-weight: 500;
  font-family: var(--font-family);
  color: var(--color-neutral-dark-darker);
  margin-right: var(--spacing-small);
}
.container-alert-address .exclamation-alert {
  margin: 0 15px;
  font-size: var(--font-big);
  color: var(--color-warning);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/AlertAddress/AlertAddress.less"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,wCAAA;EACA,8BAAA;EACA,+BAAA;EACA,YAAA;EACA,kCAAA;AACJ;AAVA;EAYQ,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,kCAAA;AACR;AAhBA;EAmBQ,cAAA;EACA,0BAAA;EACA,2BAAA;AAAR","sourcesContent":[".container-alert-address{\n    display: inline-flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    border: 2.3px solid var(--color-warning);\n    border-radius: 20px !important;\n    padding: var(--spacing-regular) ;\n    height: auto;\n    margin-top: var(--spacing-regular);\n\n    .text-alert-address{\n        font-weight: 500;\n        font-family: var(--font-family);\n        color: var(--color-neutral-dark-darker);\n        margin-right: var(--spacing-small);\n    }\n\n    .exclamation-alert{\n        margin:0 15px;\n        font-size: var(--font-big);\n        color: var(--color-warning);\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
